<template>
  <div class="el-chunk">
      <p class="emd-text _align_center">
        <span>
          <component :is="isLink ? 'a' : 'span'" :href="urlSite" :class="['_type_outline _active', iconClass]" target="_blank" rel="noopener noreferrer">
            <span>
              <emd-mundi-icon  v-if="icon === 'mundipagg' || icon === 'jpmorgan'"/>
              <emd-pagarme-icon  v-if="icon === 'pagarme'"/>
            </span>
            <span class="emd-text _color_default" style="vertical-align: 2px"> {{$t(`theme.${icon}`)}}</span>
          </component>
        </span>
        <span class="emd-text _color_nonessential eu-mx_2"> | </span>
        <span>
          <span class="emd-text _color_secondary">
            <i class="uil uil-shield-check" />
          </span>
          {{$t('safe-zone')}}
        </span>
      </p>
    </div>
</template>

<script>
import EmdPagarmeIcon from '../../../../emerald/atoms/emdPagarmeIcon/EmdPagarmeIcon.vue'
import EmdMundiIcon from '../../../../emerald/atoms/emdMundiIcon/EmdMundiIcon.vue'

export default {
  name: 'EmdFooterSecureEnv',
  components: {
    EmdMundiIcon,
    EmdPagarmeIcon
  },
  props: {
    isLink: {
      type: Boolean,
      default: true,
      required: false
    },
    urlSite: {
      type: String,
      required: false
    },
    iconClass: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'mundipagg',
      required: false
    }
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "safe-zone": "Ambiente Seguro",
    "theme": {
      "mundipagg": "Mundipagg",
      "jpmorgan": "Powered by Mundipagg",
      "pagarme": "Pagar.me"
    }
  },
  "en-US": {
    "safe-zone": "Secure Environment",
    "theme": {
      "mundipagg": "Mundipagg",
      "jpmorgan": "Powered by Mundipagg",
      "pagarme": "Pagar.me"
    }
  }
}
</i18n>
